import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useImpersonateService from '../../services/ImpersonateService';

export default function Impersonate() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [error, setError] = useState<string | null>(null);

    const { useValidateImpersonateToken } = useImpersonateService();
    const { mutate: validateToken } = useValidateImpersonateToken({
        onSuccess: () => {
            localStorage.setItem('impersonateStartTime', Date.now().toString());
            window.location.href = '/';
        },
        onError: (err: unknown) => {
            const errorResponse = err as { error?: { msg?: string } };
            setError(errorResponse?.error?.msg || t('login.impersonateError'));
            // Navegación real: en premanager/manager `/login` es de
            // competitions y el router del gestor no lo alcanzaría.
            window.location.replace('/login');
        },
    });

    useEffect(() => {
        if (!token) {
            // Navegación real: en premanager/manager `/login` es de
            // competitions y el router del gestor no lo alcanzaría.
            window.location.replace('/login');
            return;
        }

        validateToken({ token });
    }, []);

    return (
        <Box className="flex items-center justify-center min-h-screen">
            <Box className="flex flex-col items-center gap-4">
                {error ? (
                    <Typography color="error">{error}</Typography>
                ) : (
                    <>
                        <CircularProgress size={48} color="primary" />
                        <Typography color="textSecondary">
                            {t('login.impersonateLoading')}
                        </Typography>
                    </>
                )}
            </Box>
        </Box>
    );
}
